import type { Middleware } from 'redux';
import { TrackActionTypes } from 'src/reducers/track/actionCreators';
import { PageUpdateActionType } from '../reducers/page/actionCreators';
import { USER_ERROR, USER_SUCCESS } from '../reducers/user';
// @ts-ignore
import instrumentMethods from 'instrument-methods';
import type { MiddlewareAnalytics } from 'src/modules/analytics/accountMiddlewareAnalytics';

type AnalyticsLogger = (methodName: string, args: string[]) => void;

/* istanbul ignore next */
const analyticsLogger: AnalyticsLogger = (methodName, args) => {
  // eslint-disable-next-line
  console.log(`analytics.${methodName}()`, ...args);
};

const instrumentAnalytics = (analytics: MiddlewareAnalytics) =>
  /* istanbul ignore next */
  // @ts-ignore
  typeof window !== 'undefined' && window.ANALYTICS_DEBUG
    ? instrumentMethods(analytics, { after: analyticsLogger })
    : analytics;
export interface Action {
  type: string;
  payload?: any;
}

export default (analytics: MiddlewareAnalytics) => {
  const analyticsMiddleware: Middleware =
    () =>
    (next) =>
    <A extends Action>(action: A) => {
      const { type, payload } = action;
      const { trackPageView, trackLink, setLoggedInState } = analytics;

      switch (type) {
        case USER_SUCCESS: {
          setLoggedInState({
            isLoggedIn: true,
            loginId: payload && payload.id,
            profileGuid: payload && payload.emailCorrelationId,
          });
          // Moved tab tracking call to Account.tsx
          break;
        }
        case USER_ERROR: {
          setLoggedInState({
            isLoggedIn: false,
            error: `An error occured during the api.getUser() request`,
          });
          trackPageView({ eventName: 'settings_displayed' });
          break;
        }
        case PageUpdateActionType.SET_CHANGE_PASSWORD_SUCCESS: {
          trackLink({
            eventName: 'settings_password_update_succeeded',
            currentPageSection: 'change password',
            isExitLink: false,
          });
          break;
        }
        case PageUpdateActionType.SET_CHANGE_EMAIL_SUCCESS: {
          trackLink({
            eventName: 'settings_email_update_succeeded',
            currentPageSection: 'change email',
            isExitLink: false,
          });
          break;
        }
        case PageUpdateActionType.SET_DELETE_ACCOUNT_SUCCESS: {
          trackLink({
            eventName: 'delete_account_pressed',
            currentPageSection: 'delete account',
          });
          break;
        }
        case TrackActionTypes.TRACK_LINK: {
          trackLink({ link: payload, linkType: 'o' });
          break;
        }
        default: {
          break;
        }
      }
      return next(action);
    };

  return instrumentAnalytics(analytics) && analyticsMiddleware;
};
